import { render, staticRenderFns } from "./AutomationAudience.vue?vue&type=template&id=2afe9b49&scoped=true&"
import script from "./AutomationAudience.vue?vue&type=script&lang=js&"
export * from "./AutomationAudience.vue?vue&type=script&lang=js&"
import style0 from "./AutomationAudience.vue?vue&type=style&index=0&id=2afe9b49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe9b49",
  null
  
)

export default component.exports